import graphVrifyCode from "@/common/components/graph-vrifyCode/" // 图形验证码
import GDialog from "@/common/components/g-dialog/" // 弹框
import GHeader from '@/common/components/g-header/' // 头部
import refreshAcount from '@/common/components/refreshAcount/' // 刷新账户
import linksBanner from '@/common/components/links-banner/'
import noData from '@/common/components/noData/'
import loadMore from '@/common/components/load-more/'
import GCertificate from '@/common/components/g-certificate/'
import GTab from '@/common/components/g-tab/'
import GSearch from '@/common/components/g-search/'
import GButton from '@/common/components/g-button/'
import PHeader from '../views/components/p-header/'
import NHeader from '../views/components/n-header/'
import PCertificate from '../views/components/p-certificate/'
import GPageLoading from '@/common/components/g-page-loading/'  //三个点

function plugin(Vue) {
	if (plugin.installed) {
		return
	}
	Vue.component('g-header', GHeader)
  Vue.component('g-vrifycode', graphVrifyCode)
  Vue.component('g-dialog', GDialog)
  Vue.component('refresh-acount', refreshAcount)
  Vue.component('links-banner', linksBanner)
  Vue.component('no-data', noData)
  Vue.component('load-more', loadMore)
  Vue.component('g-certificate', GCertificate)
  Vue.component('g-tab', GTab)
  Vue.component('g-search', GSearch)
  Vue.component('g-button', GButton)
  Vue.component('p-header', PHeader)
  Vue.component('n-header', NHeader)
  Vue.component('p-certificate', PCertificate)
  Vue.component('g-page-loading', GPageLoading)
}

export default plugin



// WEBPACK FOOTER //
// ./src/pages/build922/utils/globalComponent.js